import Vue from 'vue'
import Vuex from 'vuex'
import user from '../modules/user'
import transformationInputTwo from '../modules/transformation_input_two'
import transformationInputOne from '../modules/transformation_input_one'
import contactUs from '../modules/contact_us'
import payments from '../modules/payments'
import assessment from '../modules/assessment'
import createPersistedState from 'vuex-persistedstate'
/* Imports for store modules */
// import {login} from '../modules/user';
/* Register Vuex with Vue */
Vue.use(Vuex)

export const store = new Vuex.Store({

  plugins: [createPersistedState(
    'loggedInUser', 'status', 'isLoggedIn'
  )],
  state: {
    submitted: false,
    notifications: '',
    errors: '',
    menus: [],
    burgerMenus: [],
    isLoading: true
  },
  mutations: {
    'NOTIFICATION': (state, notifications) => {
      state.notifications = ''
      let formattedErrors = ''
      for (let notification in notifications) {
        // console.log(notification)
        formattedErrors += notifications[notification]
      }
      // let notificationMessages = notification;
      // Check if object then loop
      /* if(typeof notification == 'object'){
                notificationMessages = '';
                for(let key in notification){
                    // skip loop if the property is from prototype
                    if (!notification.hasOwnProperty(key)) continue;
                    notificationMessages += '<br>'+notification[key];
                }
            } */
      state.notifications = formattedErrors
    },
    'ISLOADING': (state, status) => {
      // if (status[1]) {
      //   setTimeout(() => {
      state.isLoading = status
      // }, 1000)
      // }
    },
    'ERRORS': (state, errors) => {
      let formattedErrors = ''
      if (typeof errors === 'object') {
        // console.log('object')
        Object.keys(errors).forEach((key, value) => {
          // console.log(errors[key])
          formattedErrors += `${errors[key]}.<br>`
        })
      } else {
        // console.log('single error')
        formattedErrors = errors
      }
      state.errors = formattedErrors
      // console.log('55  state.errors', state.errors)
    },
    'FORM_SUBMIT': (state) => {
      // state.notifications = 'Submitting data'
      state.submitted = true
    },
    'RESET_SUBMIT': (state) => {
      state.notifications = ''
      state.submitted = false
    }
  },
  /* Register store modules */
  modules: {
    user,
    transformationInputTwo,
    transformationInputOne,
    contactUs,
    payments,
    assessment
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js